import { useState, useEffect, useMemo } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, Grid, TextField, MenuItem } from "@mui/material";
import { UPSE2Item } from "../Components/UPSE2Item";
import { instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";

const ESTADOS = ["Todos", "Pendiente de revisión", "Aprobado", "Rechazado"];
const TIPOS = ["Todos", "personas", "eventos", "documentos", "semillas"];

function UPSE2() {
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [listaU2, setListaU2] = useState([]);

  const [filtroEstado, setFiltroEstado] = useState("Todos");
  const [filtroAnio, setFiltroAnio] = useState("Todos");
  const [filtroTipo, setFiltroTipo] = useState("Todos");

  useEffect(() => {
    instance.get(`/upse2/listByUser?id=${user.id}`)
      .then((res) => setListaU2(res.data))
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message || "Error desconocido" });
        }
        setOpenDialog(true);
      })
      .finally(() => setIsLoading(false));
  }, [user.id]);

  const aniosDisponibles = useMemo(() => {
    const anios = [...new Set(listaU2.map(item => item.anio))].sort((a, b) => b - a);
    return ["Todos", ...anios];
  }, [listaU2]);

  const listaFiltrada = useMemo(() => {
    return listaU2.filter(item => {
      if (filtroEstado !== "Todos" && item.estado !== filtroEstado) return false;
      if (filtroAnio !== "Todos" && item.anio !== filtroAnio) return false;
      if (filtroTipo !== "Todos" && item.tipoPlanificacion !== filtroTipo) return false;
      return true;
    });
  }, [listaU2, filtroEstado, filtroAnio, filtroTipo]);

  return (
    <Container>
      <Box sx={{ marginTop: 4 }}>
        <h2 style={{ textAlign: 'center' }}>UPSE-2 Generados</h2>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading} loadingText="Cargando formularios...">
          <Container maxWidth="lg" sx={{ marginTop: 1, marginBottom: 5 }}>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={4}>
                <TextField
                  select fullWidth size="small" label="Estado"
                  value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}
                >
                  {ESTADOS.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  select fullWidth size="small" label="Año"
                  value={filtroAnio} onChange={(e) => setFiltroAnio(e.target.value)}
                >
                  {aniosDisponibles.map(a => <MenuItem key={a} value={a}>{a}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  select fullWidth size="small" label="Tipo de planificación"
                  value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)}
                >
                  {TIPOS.map(t => <MenuItem key={t} value={t} sx={{ textTransform: "capitalize" }}>{t}</MenuItem>)}
                </TextField>
              </Grid>
            </Grid>

            {listaFiltrada.length === 0 && !isLoading && (
              <Box sx={{ textAlign: 'center', marginTop: 4 }}>
                <p>No se encontraron formularios UPSE-2</p>
              </Box>
            )}
            {listaFiltrada.map((item) => (
              <UPSE2Item
                key={item.id}
                id={item.id}
                estado={item.estado}
                anio={item.anio}
                fechaPresentacion={item.fechaPresentacion}
                fechaRevision={item.fechaRevision}
                tipoPlanificacion={item.tipoPlanificacion}
                techoPresupuestario={item.techoPresupuestario}
                responsable={item.responsable}
                creado={item.creado}
                idCreado={item.idCreado}
                idResponsable={item.idResponsable}
                idUsuarioLogin={user.id}
                idEstado={item.idEstado}
                lugarPresentacion={item.lugarPresentacion}
                direccion={item.direccion}
              />
            ))}
          </Container>
        </LoaderBoxCircular>
      </Box>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </Container>
  );
}

export { UPSE2 };
